module.exports = __webpack_public_path__ + "img/rollcall_1.89e63457.png";